import React, { Fragment } from 'react'

/** Messsage caption component to display information about overnights selected on the date pickers. */
const ErrorCaption = (props) => {
    return (
        <div id="error_content">
            {props.caption}
        </div>
    )
}

export default ErrorCaption